import React from 'react';
import { FadeIn } from './ui/FadeIn';

export function Hero() {
  return (
    <section className="min-h-screen md:min-h-[92vh] flex flex-col justify-center max-w-content mx-auto px-pad-mob md:px-pad-desk pt-32 pb-20">
      <div className="flex flex-col md:flex-row items-center gap-16 lg:gap-24">
        
        {/* Left Column: Image */}
        <div className="w-full md:w-[45%]">
          <FadeIn>
            <div className="relative group">
              <div className="aspect-[4/5] w-full border border-hairline overflow-hidden">
                <img 
                  src="https://res.cloudinary.com/da1vahgnf/image/upload/v1777101472/abu_s7plgy.webp" 
                  alt="Md Abu Musa"
                  className="w-full h-full object-cover filter grayscale contrast-[1.05] group-hover:grayscale-0 transition-all duration-[600ms] ease-out"
                />
              </div>
              <p className="font-mono text-[13px] text-graphite uppercase mt-4">
                MD ABU MUSA  ·  [PARTNER FILLS, e.g., DHAKA, 2026]
              </p>
            </div>
          </FadeIn>
        </div>

        {/* Right Column: Content */}
        <div className="w-full md:w-[55%] flex flex-col items-start text-left">
          <FadeIn delay={0.1}>
            <p className="font-mono text-caption text-graphite uppercase mb-8">
              SENIOR JOURNALIST · LEAD GEN CONSULTANT · EST. 2021
            </p>
          </FadeIn>
          
          <FadeIn delay={0.2}>
            <h1 className="font-heading text-h1-mob md:text-h1-desk text-ink mb-8">
              Twenty years chasing stories taught me how to get people to <span className="border-b-[2px] border-accent pb-1">reply</span>. Now I do that for B2B founders.
            </h1>
          </FadeIn>
          
          <FadeIn delay={0.3}>
            <p className="font-body text-body-lg text-graphite max-w-prose-block mb-12">
              I help small B2B companies in marketing, IT, software, consulting, and staffing turn cold outreach from a guessing game into a predictable pipeline, using the same research and interviewing instincts that built a 20-year journalism career.
            </p>
          </FadeIn>
          
          <FadeIn delay={0.4} className="flex flex-col sm:flex-row items-start sm:items-center gap-6 mb-8">
            <a 
              href="#book" 
              className="group flex items-center font-body text-[17px] font-medium text-ink border-b border-ink pb-1 hover:text-graphite hover:border-graphite transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink rounded-sm"
            >
              Book a 30-minute call
              <span className="ml-2 group-hover:translate-x-1 transition-transform">→</span>
            </a>
            <a 
              href="#process" 
              className="group flex items-center font-body text-[17px] text-graphite hover:text-ink transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink rounded-sm"
            >
              See how I work
              <span className="ml-2 group-hover:translate-y-1 transition-transform">↓</span>
            </a>
          </FadeIn>
          
          <FadeIn delay={0.5} className="w-full">
            <p className="font-mono text-[12px] uppercase tracking-[0.12em] text-graphite leading-[1.6] text-left">
              BYLINES IN Daily Inqilab · The Daily Manobkantha · The Bangladesh Post // 50+ B2B CAMPAIGNS BUILT
            </p>
          </FadeIn>
        </div>
      </div>
    </section>
  );
}